export default __webpack_public_path__ + "static/media/Ethereum.c94d2cb3.svg";